import { loadSettings } from '../store/SettingsContext';

const resolveLocale = (format) => {
  if (format === 'UK') return 'en-GB';
  if (format === 'US') return 'en-US';
  return 'sv-SE';
};

const getFormatSetting = () => {
  const settings = loadSettings();
  return settings.dateFormat || 'US';
};

const buildFormatter = (options) => {
  const format = getFormatSetting();
  if (format === 'ISO') return null;
  const locale = resolveLocale(format);
  return new Intl.DateTimeFormat(locale, options);
};

export const formatWithOptions = (value, options) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const format = getFormatSetting();
  if (format === 'ISO') return date.toISOString().slice(0, 10);
  const formatter = buildFormatter(options);
  return formatter ? formatter.format(date) : date.toISOString().slice(0, 10);
};

export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const format = getFormatSetting();
  if (format === 'ISO') return date.toISOString().slice(0, 10);
  const formatter = buildFormatter({ year: 'numeric', month: 'short', day: 'numeric' });
  return formatter ? formatter.format(date) : date.toISOString().slice(0, 10);
};

export const formatDateNumeric = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const format = getFormatSetting();
  if (format === 'ISO') return date.toISOString().slice(0, 10);
  const formatter = buildFormatter({ year: 'numeric', month: '2-digit', day: '2-digit' });
  return formatter ? formatter.format(date) : date.toISOString().slice(0, 10);
};

export const formatDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const format = getFormatSetting();
  if (format === 'ISO') return date.toISOString().replace('T', ' ').slice(0, 16);
  const formatter = buildFormatter({
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  return formatter ? formatter.format(date) : date.toISOString().replace('T', ' ').slice(0, 16);
};

export const formatLongDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const format = getFormatSetting();
  if (format === 'ISO') return date.toISOString().slice(0, 10);
  const formatter = buildFormatter({
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return formatter ? formatter.format(date) : date.toISOString().slice(0, 10);
};

export const formatMonthDay = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const format = getFormatSetting();
  if (format === 'ISO') return date.toISOString().slice(0, 10);
  const formatter = buildFormatter({ month: 'short', day: 'numeric' });
  return formatter ? formatter.format(date) : date.toISOString().slice(0, 10);
};
